// src/components/FeedbackButton.tsx
import { useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import FeedbackModal from './FeedbackModal';

export default function FeedbackButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  // Hide button if not authenticated
  if (authStatus !== 'authenticated') {
    return null;
  }

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-24 right-4 md:bottom-24 md:right-6 bg-gradient-to-r from-brand to-branddark text-white px-4 py-3 md:px-5 md:py-4 rounded-full shadow-xl hover:shadow-2xl hover:scale-110 transition-all z-50 flex items-center gap-2 group"
        aria-label="Send feedback"
        data-feedback-floating
      >

        <span className="hidden sm:inline font-bold text-sm md:text-base">Feedback</span>
        <span className="inline sm:hidden font-bold text-sm">Feedback</span>
      </button>

      {/* Modal */}
      {isOpen && (
        <FeedbackModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}